import { CookiesProvider, withCookies, type ReactCookieProps } from 'react-cookie';
import { toast, ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@mui/material';

import { theme } from '@intelliarts/react-components';

import SignInPage from './components/SignInPage/SignInPageContainer';
import { DOMAIN, REDIRECT_URL } from './utils/constants';
import 'react-toastify/dist/ReactToastify.css';


function LoginApp({ cookies }: ReactCookieProps) {
  const onUserLoggedIn = () => {
    const redirectUrl = cookies!.get('originalUrl') || REDIRECT_URL;

    cookies!.remove('originalUrl', { domain: DOMAIN });

    window.location.replace(redirectUrl);
  };

  const onFailure = (err: unknown) => {
    const e = err as { details?: string; response?: { status: number } };
    e.details && console.error(e.details);

    if (e.response?.status === 403) {
      toast.error('Invalid Credentials!', {
        position: 'bottom-left',
      });
    } else {
      toast.error('Something went wrong!', {
        position: 'bottom-left',
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <SignInPage
          onUserLoggedIn={onUserLoggedIn}
          onFailure={onFailure}
        />
        <ToastContainer />
      </CookiesProvider>
    </ThemeProvider>
  );
}

export default withCookies(LoginApp);
